/**
 * Returns the complete room name
 *
 * @param {string} roomName
 * @param {string | undefined} tenant
 * @returns {string} the complete room name
 */
export var getRoomName = function getRoomName(roomName, tenant) {
  return tenant ? "".concat(tenant, "/").concat(roomName) : roomName;
};
var instancesCounter = 0;
/**
 * Generates an unique id
 * @param {string} prefix
 * @returns {string} the component id
 */

export var generateComponentId = function generateComponentId(prefix) {
  return "".concat(prefix, "-").concat(instancesCounter++);
};